<template>
  <div class="btn-group w-100">
    <button
      class="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown"
      data-bs-auto-close="outside" aria-expanded="false"
    >
      {{ $t("selecioneUmStatus", status.length, { count: status.length }) }}
    </button>
    <ul class="dropdown-menu">
      <li>
        <a class="dropdown-item">
          <div class="form-check">
            <input
              id="checkAll" class="form-check-input" type="checkbox" :checked="status.length == 4"
              @input="onCheckedAll"
            >
            <label class="form-check-label w-100" for="checkAll">{{ $t("todos") }}</label>
          </div>
        </a>
      </li>
      <li>
        <a class="dropdown-item">
          <div class="form-check">
            <input id="check1" v-model="status" class="form-check-input" :value="0" type="checkbox">
            <label class="form-check-label w-100" for="check1">{{ $t("expirada") }}</label>
          </div>
        </a>
      </li>
      <li>
        <a class="dropdown-item">
          <div class="form-check">
            <input id="check2" v-model="status" class="form-check-input" :value="1" type="checkbox">
            <label class="form-check-label w-100" for="check2">{{ $t("paga") }}</label>
          </div>
        </a>
      </li>
      <li>
        <a class="dropdown-item">
          <div class="form-check">
            <input id="check3" v-model="status" class="form-check-input" :value="2" type="checkbox">
            <label class="form-check-label w-100" for="check3">{{ $t("gratuita") }}</label>
          </div>
        </a>
      </li>
      <li>
        <a class="dropdown-item">
          <div class="form-check">
            <input id="check4" v-model="status" class="form-check-input" :value="3" type="checkbox">
            <label class="form-check-label w-100" for="check4">{{ $t("cancelada") }}</label>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: { type: Array, required: true },
  },
  emits: ['update:modelValue'],
  data: (props) => ({ status: props.modelValue }),
  watch: {
    status(newStatus) {
      this.$emit('update:modelValue', this.status);
    },
  },
  methods: {
    onCheckedAll() { this.status = this.status.length === 4 ? [] : [0, 1, 2, 3]; },
  },
};
</script>
